import type { ChangeEvent, FormEvent, RefObject, ComponentProps } from 'react';

export type ControlledSearchBoxProps = ComponentProps<'div'> & {
  inputRef: RefObject<HTMLInputElement>;
  isSearchStalled: boolean;
  onChange(event: ChangeEvent): void;
  onReset(event: FormEvent): void;
  onSubmit?(event: FormEvent): void;
  placeholder?: string;
  value: string;
};

export function ControlledSearchBox({
  inputRef,
  isSearchStalled,
  onChange,
  onReset,
  onSubmit,
  placeholder,
  value,
  ...props
}: ControlledSearchBoxProps) {
  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (onSubmit) {
      onSubmit(event);
    }

    if (inputRef.current) {
      inputRef.current.blur();
    }
  }

  function handleReset(event: FormEvent) {
    event.preventDefault();
    event.stopPropagation();

    onReset(event);

    if (inputRef.current) {
      inputRef.current.focus();
    }
  }

  return (
    <div className="relative border-b border-[#333]" {...props}>
      <form
        action=""
        className="ais-SearchBox-form quick-search relative flex w-full items-stretch"
        noValidate
        onSubmit={handleSubmit}
        onReset={handleReset}
      >
        <input
          ref={inputRef}
          className="ais-SearchBox-input box-content grow truncate border-none pb-18 pl-48 pt-20 text-16 font-medium text-[#333]  transition placeholder:truncate placeholder:font-medium placeholder:text-[#333] focus:outline-none md:pr-24 lg:pb-10 lg:pt-12 placeholder:xl:text-16 3xl:pb-18 3xl:pt-20 3xl:text-20 placeholder:3xl:text-20"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          placeholder={placeholder}
          spellCheck={false}
          maxLength={512}
          type="search"
          value={value}
          onChange={onChange}
        />
        <button className="ais-SearchBox-submit" type="submit" title="Submit the search query.">
        </button>
      </form>
    </div>
  );
}
